if (!customElements.get('prosper-lookbook')) {
  class ProsperLookbook extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.prosper-lightbox');
      this.image = this.querySelector('.prosper-lightbox__image');
      this.triggers = Array.from(this.querySelectorAll('[data-lookbook-index]'));
      if (!this.dialog || typeof this.dialog.showModal !== 'function' || this.triggers.length === 0) return;

      this.triggers.forEach((trigger, position) => {
        trigger.addEventListener('click', () => this.open(position));
      });
      this.querySelector('[data-lightbox-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-lightbox-prev]').addEventListener('click', () => this.step(-1));
      this.querySelector('[data-lightbox-next]').addEventListener('click', () => this.step(1));
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        const trigger = this.triggers[this.position];
        if (trigger) trigger.focus();
      });

      const single = this.triggers.length < 2;
      this.querySelector('[data-lightbox-prev]').hidden = single;
      this.querySelector('[data-lightbox-next]').hidden = single;
    }

    open(position) {
      this.show(position);
      if (!this.dialog.open) this.dialog.showModal();
    }

    step(direction) {
      const count = this.triggers.length;
      this.show((this.position + direction + count) % count);
    }

    show(position) {
      this.position = position;
      const trigger = this.triggers[position];
      this.image.src = trigger.dataset.full;
      this.image.alt = trigger.dataset.alt || '';
    }
  }

  customElements.define('prosper-lookbook', ProsperLookbook);
}
